// extracted by mini-css-extract-plugin
export default {"wrapper":"Chatbox_wrapper__JobCY","icon-action":"Chatbox_icon-action__ogSFr","icon-send":"Chatbox_icon-send__tJilo"};